var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordshow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.455,
    height: 15.812,
    viewBox: "0 0 26.455 15.812",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_524",
    "data-name": "Group 524",
    transform: "translate(0.537 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M25.3,113.767c-.2-.291-5.005-7.105-12.6-7.105-6.518,0-12.326,6.775-12.571,7.064a.531.531,0,0,0,0,.683c.244.289,6.053,7.064,12.571,7.064s12.326-6.775,12.571-7.064A.529.529,0,0,0,25.3,113.767Zm-12.6,6.648c-5.225,0-10.194-4.983-11.456-6.348C2.5,112.7,7.463,107.72,12.7,107.72c6.114,0,10.429,4.976,11.483,6.319C22.962,115.361,17.965,120.416,12.7,120.416Z",
    transform: "translate(0 -106.662)",
    fill: "#444",
    stroke: "#444",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    transform: "translate(8.463 2.778)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M174.894,170.662a4.232,4.232,0,1,0,4.232,4.232A4.236,4.236,0,0,0,174.894,170.662Zm0,7.406a3.174,3.174,0,1,1,3.174-3.174A3.178,3.178,0,0,1,174.894,178.068Z",
    transform: "translate(-170.662 -170.662)",
    fill: "#444",
    stroke: "#444",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordshow);
export default __webpack_public_path__ + "static/media/passwordshow.62a6985fbd2ab4b676a7a89c878f5295.svg";
export { ForwardRef as ReactComponent };